import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { concat, merge, of, from, Subscription, Subject } from 'rxjs';
import { map, switchMap, concatMap, finalize, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';

import { Product, ProductListFetchParams } from 'src/app/shared/product'
import { ProductGroup } from 'src/app/shared/product-group'

import { SecurityGroups } from 'src/app/shared/securitygroups';
import { CliListEntry } from 'src/app/shared/cli-list-entry';
import { Person } from 'src/app/shared/person';
import { Client } from 'src/app/shared/client';
import { DocListEntry, DocTypes } from 'src/app/shared/doc-list-entry';
import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';
import { ProductInfo } from 'src/app/shared/product'
import { Currency } from 'src/app/shared/currency';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocumentStackService } from 'src/app/services/document-stack.service'

import { ProductApiService } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { ClientApiService } from 'src/app/services/client-api.service';
import { RestApiService } from '../../services/rest-api.service';

@Component({
  selector: 'app-new-document-dlg-process-po',
  templateUrl: './new-document-dlg-process-po.component.html',
  styleUrls: ['./new-document-dlg-process-po.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessPoComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;

  private _productInfoQuery: Subscription;

  private diCopyQuery: Subscription;

  /*
   * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
   */
  @Input() parentDocument: Document;

  /*
   * Therefore, to keep source object untouched (immutable ????)
   * we will expect alone/independent copy of DocItems as Input parameter
   * 
   */

  @Input() docItems: DocItems[];

  @Input() newDocument: Document;

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;

  count: number = -1;

  sourceDocItems: DocItems[];

  @Input() countEmptyDocItems: boolean = false;

  @Output() blocking: EventEmitter<boolean> = new EventEmitter();

  actions =
    [
      { name: 'На основе валютной цены', value: 1, disabled: false },
      { name: 'Копировать цену инвойса', value: 2, disabled: false },
      { name: 'Удалить существующие позиции', value: 3, disabled: false },
      { name: 'Учитывать пустые строки', value: 10, disabled: false },
    ];

  selectedActions: any = [1, 2, 3];

  private listOptions$ = new Subject<number>();
  private currencyQuery: Subscription;

  constructor(
    private restApi: RestApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private prodApi: ProductApiService,
  ) { }

  round2(n: number) {
    return Math.round((n * 100)) / 100;
  }

  round1(n: number) {
    return Math.round((n * 10)) / 10;
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgProcessInvoiceComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
            this.processDocItems();
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.sourceDocItems = [... this.docItems];
            this.count = this.sourceDocItems.length;
            this.processDocItems();
          }
          break;

        case 'parentDocument':
          if (this.parentDocument) {

            if (this.parentDocument.items) {
              this.processDocItems();
            }
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessInvoiceComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this._productInfoQuery) { this._productInfoQuery.unsubscribe(); }

    if (this.diCopyQuery) { this.diCopyQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessInvoiceComponent in ngOnInit');

    /*
     * TODO: Make subscription to newDocument currency rate, because it is quite complex task to wait the set the rate in the main thread
     * Potentially problematic due to different sources ??????
     */

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
  }

  processDocItems() {
    console.log('*** NewDocumentDlgProcessInvoiceComponent in processDocItems');
    /*
     * Get Actual currency rate for newDocument
     * Those one in newDocument.DOCRATEVAL from createNewDocument Dialog would arrive later
     * 
     */
    this.currencyQuery =
      this.listOptions$.pipe(
        debounceTime(50),
        switchMap(currid => this.restApi.getCurrencyInfoByID(currid).pipe(

          concatMap(currency => {
            console.log('*** NewDocumentDlgProcessInvoiceComponent in Subscription: data=(' + JSON.stringify(currency) + ')');

            this.blocking.emit(true);

            this.newDocument.DOCRATEVAL = currency[0].CURRATE;
            this.newDocument.items = [];

            return from(this.docItems).pipe( map(di => {

                let ndi: DocItems = {
                  ...di,
                  ... {
                    DOCITEMID: -2,
                    cloneIndex: 0,
                    DOCITEMCURRID: this.newDocument.DOCCURRID,
                    DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                    DOCITEMPRICE: di.DOCITEMVPRICE * this.newDocument.DOCRATEVAL,
                  }
                };
                //environment.production || console.table(ndi);

                if (!this.selectedActions.includes(2)) {
                  ndi.U4ETKA = null;
                }

                if (this.newDocument.DOCCURRID == this.parentDocument.DOCCURRID) {
                  /*
                    * Both parent and new documents have same currencies
                    * 
                    * Very simple price calulation based on old and new rates
                    */

                  if (!this.selectedActions.includes(1)) {
                    ndi.DOCITEMPRICE = di.DOCITEMPRICE;
                    ndi.DOCITEMVPRICE = ndi.DOCITEMPRICE / this.newDocument.DOCRATEVAL;
                  }

                } else {
                  /*
                    * Parent and new documents have different currencies
                    * 
                    * Complex price calulation - we need either both rates for selected currency to update the price
                    * 
                    * a) based on currency price
                    *
                    * b) based on main price
                    * 
                    */

                }
                ndi.DOCITEMSUM = ndi.DOCITEMPRICE * ndi.DOCITEMQTY;

                this.newDocument.items.push(ndi);
              }),

              finalize(() => {
                this.blocking.emit(false);
              })
            );
          }),
        ))
      ).subscribe();

    this.listOptions$.next(this.newDocument.DOCCURRID);
  }

  onDocTypeChanges(event) {
    console.log('*** NewDocumentDlgProcessInvoiceComponent onDocTypeChanges ' + JSON.stringify(event));

    if (event.value.includes(1)) {
      console.log('*** NewDocumentDlgProcessInvoiceComponent doCurrencyBased document ' + JSON.stringify(event.value));
      /*
       * TODO: Check whether currency of newDocument equal to those in parentDocument
       *       May be we need more sofisticated parameters checking
       */
    }
    if (event.value.includes(2)) {
      console.log('*** NewDocumentDlgProcessInvoiceComponent copy U4etka info' + JSON.stringify(event.value));
    }
    this.processDocItems();
  }

  onClearRows(event) {
    console.log('*** NewDocumentDlgProcessInvoiceComponent onClearRows ' + JSON.stringify(event));

    this.newDocument.items = [];
  }

  onRefreshRows(event) {
    console.log('*** NewDocumentDlgProcessInvoiceComponent onRefreshRows ' + JSON.stringify(event));

    this.processDocItems();
  }
}
